import {Message} from '@gongxigames/framework/slot/types';

export const SLOW_CONNECTION: Message = {
    id: 'SLOW_CONNECTION',
    type: 'normal',
    title: {id: 'warning'},
    message: {id: 'slowConnection'},
    withoutBorder: true
};

export const CONNECTION_TIMEOUT: Message = {
    id: 'CONNECTION_TIMEOUT',
    type: 'error',
    title: {id: 'warning'},
    message: {id: 'connectionTimeout'},
    withoutBorder: true
};

export const GAME_UNAVAILABLE: Message = {
    id: 'GAME_UNAVAILABLE',
    type: 'error',
    title: {id: 'error'},
    message: {id: 'error2'}
};

export const GAME_DISABLED: Message = {
    id: 'GAME_DISABLED',
    type: 'error',
    title: {id: 'error'},
    message: {id: 'gameDisabled'},
    buttons: [
        {action: 'go_to_home', title: 'quit'}
    ]
};

export const INSUFFICIENT_FUNDS: Message = {
    id: 'INSUFFICIENT_FUNDS',
    type: 'error',
    title: {id: 'error'},
    message: {id: 'insufficientFunds'},
    buttons: [
        {action: 'reload', title: {id: 'reload'}},
        {action: 'deposit', title: {id: 'deposit'}}
    ]
};

export const INSUFFICIENT_PROMOTION_BALANCE: Message = {
    id: 'INSUFFICIENT_PROMOTION_BALANCE',
    type: 'error',
    title: {id: 'error'},
    message: {id: 'insufficientPromotionBalance'},
    buttons: [
        {action: 'reload', title: {id: 'reload'}}
    ]
};
export const INTERNAL_ERROR: Message = {
    id: 'INTERNAL_ERROR',
    type: 'error',
    title: {id: 'error'},
    message: {id: 'internalError'},
    buttons: [{
        title: {id: 'reload'},
        action: 'reload'
    }]
};

export const PLAYER_BLOCKED: Message = {
    id: 'PLAYER_BLOCKED',
    type: 'error',
    title: {id: 'error'},
    message: {id: 'playerBlocked'}
};

export const BET_PLACE: Message = {
    id: 'BET_PLACE',
    type: 'normal',
    title: {id: 'error'},
    message: {id: 'betPlaceError'},
    buttons: [{action: 'reload', title: {id: 'ok'}}]
};

export const SESSION_EXPIRED: Message = {
    id: 'SESSION_EXPIRED',
    type: 'error',
    title: {id: 'error'},
    message: {id: 'sessionExpired'}
};

export const SESSION_TIME_LIMIT_REACHED: Message = {
    id: 'SESSION_TIME_LIMIT_REACHED',
    type: 'error',
    title: {id: 'error'},
    message: {id: 'sessionTimeLimitReached'}
};

export const UNRESOLVED_SESSION: Message = {
    id: 'UNRESOLVED_SESSION',
    type: 'normal',
    title: {id: 'error'},
    message: {id: 'brokenRound'},
    buttons: [{
        title: {id: 'ok'},
        action: 'reload'
    }]
};

export const CONNECTION_ERROR: Message = {
    id: 'CONNECTION_ERROR',
    type: 'error',
    title: {id: 'error'},
    message: {id: 'connectionError'},
    buttons: [{
        title: {id: 'restart'},
        action: 'reload'
    }],
    priority: 99999
};

export const LOW_BALANCE: Message = {
    id: 'LOW_BALANCE_ERROR',
    type: 'normal',
    title: {id: 'error'},
    message: {id: 'insufficientFunds'},
    buttons: [
        {
            title: {id: 'ok'},
            action: 'close_message'
        }, {
            title: {id: 'deposit'},
            action: 'deposit'
        }
    ]
};

export const LOST_CONNECTION: Message = {
    id: 'LOST_CONNECTION',
    type: 'error',
    title: {id: 'error'},
    message: {id: 'connectionError'},
    priority: 9999
};

export const TEMPORARY_ERROR: Message = {
    id: 'TEMPORARY_ERROR',
    type: 'normal',
    title: {id: 'error'},
    message: {id: 'temporaryError'}
};

export const CUSTOM: Message = {
    id: 'CUSTOM_MESSAGE',
    type: 'error',
    title: '',
    message: '',
    buttons: [{
        title: {id: 'ok'},
        action: 'reload'
    }]
};

export const NOT_CRITICAL_CUSTOM_MESSAGE: Message = {
    id: 'NOT_CRITICAL_CUSTOM_MESSAGE',
    type: 'error',
    title: {id: 'error'},
    message: '',
    buttons: [{
        title: {id: 'ok'},
        action: 'reload'
    }]
};

export const CRITICAL_CUSTOM_MESSAGE: Message = {
    id: 'CRITICAL_CUSTOM_MESSAGE',
    type: 'error',
    title: {id: 'error'},
    message: '',
    buttons: [{
        title: {id: 'ok'},
        action: 'reload'
    }]
};

export const BROWSER_NOT_SUPPORTED: Message = {
    id: 'BROWSER_NOT_SUPPORTED',
    type: 'error',
    title: {id: 'error'},
    message: {id: 'browserNotSupported'}
};

export const WEBGL_CAN_NOT_SUPPORTED: Message = {
    id: 'WEBGL_CAN_NOT_SUPPORTED',
    type: 'error',
    title: {id: 'error'},
    message: {id: 'webGLCanNotSupported'},
    rendererType: 'HTML'
};

export const CLOSE_GAME_MESSAGE: Message = {
    id: 'CLOSE_GAME_MESSAGE',
    type: 'error',
    title: {id: 'closeGame'},
    message: {id: 'closeGameWindow'}
};

export const WEBGL_LOST_CONTEXT_MESSAGE: Message = {
    id: 'CRITICAL_CUSTOM_MESSAGE',
    type: 'error',
    title: {id: 'error'},
    message: {id: 'webglLostContext'},
    buttons: [{
        title: {id: 'reload'},
        action: 'reload'
    }],
    rendererType: 'HTML'
};

export const HARDWARE_ACCELERATION_DISABLED_MESSAGE: Message = {
    id: 'CRITICAL_CUSTOM_MESSAGE',
    type: 'normal',
    title: {id: 'warning'},
    message: {id: 'hardwareAccelerationDisabled'},
    buttons: [{
        title: {id: 'ok'},
        action: 'close_message'
    }],
    rendererType: 'HTML'
};

export const CUSTOM_ERROR: Message = {
    id: 'CUSTOM_ERROR',
    type: 'error',
    title: '',
    message: ''
};

export const BROKEN_ROUND: Message = {
    id: 'BROKEN_ROUND',
    type: 'error',
    title: {id: 'error'},
    message: {id: 'brokenRound'},
    buttons: [{
        title: {id: 'ok'},
        action: 'reload'
    }]
};

export const INACTIVITY_TIMER: Message = {
    id: 'INACTIVITY TIMER',
    type: 'error',
    title: {id: 'inactivityTimerTitle'},
    message: {id: 'inactivityTimerMessage'},
    buttons: [{
        action: 'reload',
        title: {id: 'reload'}
    }]
};

export const INACTIVITY_TIMER_WITH_HOME_BUTTON: Message = {
    ...INACTIVITY_TIMER,
    buttons: [
        {
            action: 'reload',
            title: {id: 'reload'}
        },
        {
            action: 'go_to_home',
            title: {id: 'quit'}
        }
    ]
};

// TODO: it's temporary solution. Later will agreed error customization with BE guys
export const CUSTOM_SERVER_ERROR: Message = {
    id: 'CUSTOM_SERVER_ERROR',
    type: 'error',
    title:  {id: 'error'},
    message: ''
};

export const UNAVAILABLE_LOCATION: Message = {
    id: 'UNAVAILABLE_LOCATION',
    type: 'error',
    title: {id: 'error'},
    message: {id: 'unavailableLocation'},
    buttons: [
        {action: 'go_to_home', title: 'quit'}
    ]
};

export const PROMOTION_TERMINATED_WARNING: Message = {
    id: 'PROMOTION_TERMINATED_WARNING',
    type: 'normal',
    title: {id: 'promotionInfo'},
    message: {id: 'promotionNotAvailable'},
    buttons: [{
        title: {id: 'ok'},
        action: 'close_message'
    }]
};

export const PROMOTION_TERMINATED_ERROR: Message = {
    id: 'PROMOTION_TERMINATED_ERROR',
    type: 'error',
    title: {id: 'error'},
    message: {id: 'promotionNotAvailable'},
    buttons: [{
        title: {id: 'restart'},
        action: 'reload'
    }]
};

export const PROMOTION_OPTED_IN_WARNING: Message = {
    id: 'PROMOTION_TERMINATED_WARNING',
    type: 'normal',
    title: {id: 'promotionOptedInTitle'},
    message: {id: 'promotionOptedInText'},
    buttons: [{
        title: {id: 'ok'},
        action: 'close_message'
    }]
};

export const PROMOTION_OPTED_OUT_WARNING: Message = {
    id: 'PROMOTION_TERMINATED_WARNING',
    type: 'normal',
    title: {id: 'promotionOptedOutPopupTitle'},
    message: {id: 'promotionOptedOutPopupText'},
    buttons: [{
        title: {id: 'ok'},
        action: 'close_message'
    }]
};

export const PROMOTION_COMPLETED_WARNING: Message = {
    id: 'PROMOTION_TERMINATED_WARNING',
    type: 'normal',
    title: {id: 'promotionCompletedTitle'},
    message: {id: 'promotionCompletedText'},
    buttons: [{
        title: {id: 'ok'},
        action: 'close_message'
    }]
};